"use client";
import { useContext } from "react";
import ColorIcon from "./ColorIcon";
import ColorName from "./ColorName";
import { AppContext } from "./AppContext";

export default function Background() {
  const { bg, customBg } = useContext(AppContext);

  return (
    <div className="flex flex-col">
      <div className="title">Background</div>
      <div className="colorItem border-color relative flex h-12 items-center gap-2 overflow-hidden rounded-md border px-2 pl-0">
        <div className="iw">B</div>
        <ColorName fallBack="Bg Color" hsla={customBg || bg} />
        <div className="ml-auto">
          <ColorIcon value={customBg || bg} isBg={true} />
        </div>
      </div>
    </div>
  );
}
